import React, { useContext } from "react";

import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import PlannedMealHeader from "./PlannedMealHeader";
import PlannedMealItemsCell from "./PlannedMealItemsCell";
import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()({
  root: {
    position: "relative",
    display: "flex",
    alignItems: "stretch",
    width: "max-content", // for sticky row headers to work all the way
    minHeight: 200,
  },
  header: {
    position: "sticky",
    left: 0,
    minWidth: 125,
    maxWidth: 125,
    border: "2px solid #fafafa",
    backgroundColor: colors.white,
    zIndex: 10,
  },
  cell: {
    minWidth: 400,
    maxWidth: 400,
  },
});

const PlannedMealRows: React.FC = observer(() => {
  const { classes } = useStyles();

  const store = useContext(MealPlanFormStore.Context);

  return (
    <>
      {store.rows.map((plannedMeal) => (
        <div key={plannedMeal.uuid} className={classes.root}>
          <div className={classes.header}>
            <PlannedMealHeader plannedMeal={plannedMeal} />
          </div>
          {plannedMeal.cells.map((cell) => (
            <PlannedMealItemsCell
              key={cell.key}
              className={classes.cell}
              cell={cell}
            />
          ))}
        </div>
      ))}
    </>
  );
});

export default PlannedMealRows;
